import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$organizationName/settings/_access/teams/$teamId/')({
  component: () => null,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$organizationName/settings/teams/$teamId/$tab',
      params: { organizationName: params.organizationName, teamId: params.teamId, tab: 'users' },
    });
  },
});
